import React from "react";
import { Download, ExternalLink } from "lucide-react";

const Hero = ({ isDarkMode, scrollToSection }) => {
  const handleCVDownload = () => {
    const link = document.createElement("a");
    link.href = "/cv.pdf"; // Place your CV file in the public folder
    link.download = "Ammad_Ahmed_CV.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section
      id="home"
      className={`pt-24 pb-16 relative overflow-hidden transition-all duration-500 ${
        isDarkMode
          ? "bg-gradient-to-br from-gray-900 via-gray-800 to-purple-900"
          : "bg-gradient-to-br from-blue-50 via-white to-purple-50"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h1
              className={`text-4xl md:text-6xl lg:text-7xl font-bold mb-6 ${
                isDarkMode ? "text-white" : "text-gray-900"
              }`}
            >
              Hi, I'm{" "}
              <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent animate-pulse">
                Ammad Ahmed
              </span>
            </h1>

            <div className="text-2xl md:text-3xl mb-8 font-semibold">
              <span className={isDarkMode ? "text-gray-300" : "text-gray-600"}>
                Software Engineer &{" "}
              </span>
              <span className="bg-gradient-to-r from-green-600 to-teal-600 bg-clip-text text-transparent">
                Full Stack Developer
              </span>
            </div>

            <p
              className={`text-lg mb-8 max-w-2xl leading-relaxed ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Passionate about creating digital solutions that make an impact.
              With 1.5 years of experience in web development, I specialize in
              building scalable backends, modern frontends, and custom e-commerce
              solutions using technologies like JavaScript, React.js, Node.js,
              NestJS, PHP, and Shopify.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start text-center">
              <button
                onClick={() => scrollToSection("projects")}
                className="group bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full hover:shadow-2xl hover:shadow-blue-500/25 transform hover:-translate-y-2 transition-all duration-300 font-semibold"
              >
                <span className="flex items-center justify-center gap-2">
                  View My Work
                  <ExternalLink className="w-5 h-5 group-hover:rotate-45 transition-transform duration-300" />
                </span>
              </button>

              <button
                onClick={handleCVDownload}
                className={`group border-2 border-blue-600 px-8 py-4 rounded-full transition-all duration-300 flex items-center justify-center gap-2 font-semibold ${
                  isDarkMode
                    ? "text-blue-400 hover:bg-blue-600 hover:text-white hover:shadow-lg hover:shadow-blue-500/25"
                    : "text-blue-600 hover:bg-blue-600 hover:text-white hover:shadow-lg hover:shadow-blue-500/25"
                } transform hover:-translate-y-2`}
              >
                <Download className="w-5 h-5 group-hover:animate-bounce" />
                Download CV
              </button>
            </div>
          </div>

          <div className="flex-1 max-w-md relative">
            <div className="relative">
              {/* Animated background circles */}

              {/* Main profile area */}
              <div
                className={`relative w-80 h-80 rounded-full mx-auto flex items-center justify-center transition-all duration-500 overflow-hidden ${
                  isDarkMode
                    ? "bg-gray-800 text-gray-400"
                    : "bg-gray-200 text-gray-500"
                } border-4 border-gradient-to-r from-blue-500 to-purple-500`}
              >
                {/* Image inside circle */}
                <img
                  src="/profile.png"
                  alt="Profile"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
